import { ErrorHandler, Injectable } from "@angular/core";
import { logs, SeverityNumber } from "@opentelemetry/api-logs";
import { ATTR_EXCEPTION_MESSAGE, ATTR_EXCEPTION_STACKTRACE, ATTR_EXCEPTION_TYPE, ATTR_URL_QUERY } from "@opentelemetry/semantic-conventions";
import { Map } from "immutable";
import { navigationContext } from "./navigation-context";

@Injectable()
export class TelemetryErrorHandler extends ErrorHandler {
  override handleError(error: unknown): void {
    try {
      // The HTTP interceptor already reports failed requests; HttpErrorResponse, NSwag's ApiException and ProblemDetails all carry a status.
      if (typeof (error as { status?: unknown } | null)?.status !== "number") {
        this._emit(error);
      }
    } catch {
      // A telemetry failure must never replace the exception being reported.
    }

    super.handleError(error);
  }

  private _emit(error: unknown): void {
    // Duck-typed: anything can be thrown, not only Error.
    const shaped: Partial<Error> = (error ?? {}) as Partial<Error>;
    const message: string = typeof shaped.message === "string" ? shaped.message : String(error);

    logs.getLogger("lims-errors").emit({
      severityNumber: SeverityNumber.ERROR,
      severityText: SeverityNumber[SeverityNumber.ERROR],
      body: message,
      attributes: Map({
        [ATTR_EXCEPTION_TYPE]: typeof shaped.name === "string" ? shaped.name : typeof error,
        [ATTR_EXCEPTION_MESSAGE]: message,
        [ATTR_URL_QUERY]: location.search.replace(/^\?/, ""),
        [ATTR_EXCEPTION_STACKTRACE]: typeof shaped.stack === "string" ? shaped.stack : "",
      })
        .filter(Boolean)
        .toObject(),
      context: navigationContext(),
    });
  }
}
